import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useDispatch } from 'react-redux';
import axios from 'axios';

import './MobileWidgetHeaderBtn.css';
import { updateOurPrice } from '../../features/MiniBookingWidget/MiniBookingWidgetSlice';
import BarsLoadingIndicator from '../common/barsLoadingIndicator/BarsLoadingIndicator';
import { applyImportantStyles, isValidPrice } from '../../lib';

const MobileWidgetHeaderBtn = ({
    price,
    priceText,
    currencySymbol,
    url,
    colors,
    handleClick,
    disableArrowBtn,
    showAlways = false,
    classes = '',
    styles,
}) => {
    const isPriceAvailable =
        typeof price === 'string' && !price.startsWith('getprice');
    const loading = !isPriceAvailable;
    const dispatch = useDispatch();

    useEffect(async () => {
        if (typeof price === 'string' && price.startsWith('getprice')) {
            const url = price.split('getprice:')[1];

            try {
                const response = await axios.get(url);

                if (response && response.data) {
                    dispatch(
                        updateOurPrice({
                            ourPrice: response.data?.ourPrice,
                        })
                    );
                }
            } catch (error) {
                dispatch(
                    updateOurPrice({
                        ourPrice: {},
                    })
                );
            }
        }
        // return () => {
        //     cleanup
        // }
    }, [price]);

    const onSubmit = (event) => {
        if (url === '') {
            event.preventDefault();
        }
    };

    const showBtn = showAlways || (isValidPrice(price) && priceText);

    return (
        <>
            {showBtn && (
                <div
                    className={`ab-mobile-widget-header-btn-cnt ${classes}`}
                    style={{ ...styles.containerStyles }}
                >
                    <form
                        action={url}
                        method="get"
                        target="_blank"
                        onSubmit={onSubmit}
                        className={!url ? 'ab-no-pointer-events' : ''}
                    >
                        <button
                            style={{
                                backgroundColor: colors?.primaryBackgroundColor,
                                color: colors?.primaryTextColor,
                                ...styles.buttonStyles,
                            }}
                            type="submit"
                            onClick={handleClick}
                            ref={(el) => {
                                applyImportantStyles(el, {
                                    'background-color':
                                        colors?.primaryBackgroundColor,
                                    color: colors?.primaryTextColor,
                                    padding: '0 19px',
                                    margin: '0px',
                                    fontWeight: '100',
                                    'font-weight': '100',
                                });
                            }}
                        >
                            {price ? (
                                <div className="ab-our-price--full">
                                    {loading ? (
                                        <>
                                            <span
                                                style={{
                                                    color: colors?.primaryTextColor,
                                                }}
                                            >
                                                {priceText} &nbsp;
                                            </span>
                                            <BarsLoadingIndicator />
                                        </>
                                    ) : (
                                        <>
                                            <span
                                                style={{
                                                    color: colors?.primaryTextColor,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <svg
                                                    version="1.0"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 512.000000 512.000000"
                                                    preserveAspectRatio="xMidYMid meet"
                                                    style={{
                                                        marginRight: '9px',
                                                    }}
                                                >
                                                    <g
                                                        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                                        fill="#000000"
                                                        stroke="none"
                                                        style={{
                                                            fill: colors?.primaryTextColor,
                                                        }}
                                                    >
                                                        <path
                                                            d="M273 4685 c-106 -33 -204 -122 -245 -223 l-23 -57 -3 -648 -3 -647
26 -26 c21 -21 32 -25 58 -20 66 13 67 16 67 342 l0 294 2410 0 2410 0 0
-1282 0 -1283 -24 -50 c-25 -54 -71 -100 -123 -122 -25 -10 -114 -13 -397 -13
l-365 0 -27 -23 c-36 -31 -38 -82 -4 -109 22 -18 44 -19 414 -16 l391 3 67 33
c82 40 157 119 190 200 l23 57 0 1655 0 1655 -23 57 c-33 81 -108 160 -190
200 l-66 33 -194 3 c-190 3 -195 3 -218 -19 -29 -27 -31 -68 -5 -100 19 -23
25 -24 203 -29 100 -4 195 -11 209 -17 46 -20 91 -66 115 -118 23 -48 24 -58
24 -307 l0 -258 -2410 0 -2410 0 0 258 c0 249 1 259 24 307 23 51 68 97 115
118 19 9 529 13 1949 17 l1924 5 19 24 c26 32 24 73 -4 99 l-23 22 -1920 -1
c-1558 0 -1927 -3 -1961 -14z"
                                                        />
                                                        <path
                                                            d="M568 4318 c-51 -30 -72 -73 -65 -134 10 -91 105 -146 188 -109 103
47 107 200 6 248 -47 23 -84 21 -129 -5z"
                                                        />
                                                        <path
                                                            d="M1000 4321 c-96 -51 -96 -190 0 -243 93 -51 206 26 197 135 -9 99
-110 155 -197 108z"
                                                        />
                                                        <path
                                                            d="M1431 4323 c-124 -65 -93 -242 45 -259 73 -9 141 46 150 122 13 104
-103 186 -195 137z"
                                                        />
                                                        <path
                                                            d="M1134 2905 c-15 -10 -49 -94 -115 -279 -52 -146 -96 -266 -99 -266
-3 0 -45 117 -93 259 -49 143 -97 267 -106 275 -42 38 -121 5 -121 -49 0 -46
249 -758 271 -777 25 -21 68 -23 93 -5 10 7 58 126 112 276 52 146 96 266 98
268 2 2 43 -114 92 -257 49 -144 97 -270 107 -281 23 -25 78 -25 101 0 17 19
276 743 276 773 0 49 -51 83 -101 66 -34 -12 -38 -19 -139 -311 -49 -140 -86
-233 -90 -225 -4 7 -45 123 -90 258 -86 254 -105 290 -153 290 -13 0 -32 -7
-43 -15z"
                                                        />
                                                        <path
                                                            d="M2517 2898 c-14 -14 -56 -119 -111 -273 -49 -137 -92 -253 -95 -258
-4 -4 -47 109 -96 250 -48 142 -95 266 -103 276 -33 38 -107 17 -125 -36 -8
-22 244 -761 269 -788 24 -27 75 -25 101 4 11 12 60 135 108 272 49 138 91
253 94 257 4 4 47 -110 96 -254 49 -144 97 -270 107 -280 23 -23 70 -23 96 0
14 11 66 145 153 396 124 357 131 381 118 405 -36 64 -109 57 -138 -13 -10
-22 -53 -143 -97 -268 -43 -125 -81 -224 -85 -220 -3 4 -45 122 -92 262 -59
173 -94 261 -108 273 -29 23 -66 21 -92 -5z"
                                                        />
                                                        <path
                                                            d="M3887 2908 c-19 -14 -41 -70 -142 -356 -38 -106 -71 -189 -75 -185
-4 4 -45 118 -90 253 -46 135 -92 255 -103 268 -40 44 -127 15 -127 -42 0 -34
254 -760 272 -778 21 -21 66 -23 93 -4 14 9 52 102 115 279 52 146 97 264 99
261 3 -3 45 -120 93 -261 48 -141 95 -264 104 -274 24 -27 76 -25 101 4 22 25
273 731 273 770 0 58 -76 92 -119 53 -11 -10 -57 -126 -106 -269 -49 -139 -91
-255 -95 -259 -3 -5 -46 110 -95 254 -49 144 -97 270 -107 280 -21 21 -67 24
-91 6z"
                                                        />
                                                        <path
                                                            d="M22 2847 l-22 -24 2 -864 3 -864 23 -57 c33 -81 108 -160 190 -200
l67 -33 740 -5 740 -5 60 -157 c33 -86 69 -166 79 -178 25 -26 73 -39 111 -28
18 5 80 59 165 143 l135 135 115 -116 c151 -152 181 -174 238 -174 44 0 48 3
149 102 141 138 153 165 113 241 l-20 37 420 0 c407 0 421 1 440 20 27 27 26
81 -1 106 -20 18 -46 19 -518 22 l-497 3 -49 49 -49 50 137 138 c123 124 139
143 144 179 7 50 -18 96 -62 117 -16 8 -322 124 -680 257 -733 274 -722 271
-781 207 -28 -31 -34 -45 -33 -80 0 -30 50 -175 163 -478 l163 -435 -681 -3
c-440 -2 -693 1 -716 7 -52 15 -110 68 -136 125 l-24 51 0 846 0 846 -23 21
c-31 29 -77 29 -105 -1z m2173 -1267 c297 -110 546 -203 554 -206 10 -3 -31
-51 -126 -147 -78 -78 -144 -152 -148 -164 -3 -12 -1 -33 6 -45 6 -13 77 -89
157 -171 l146 -147 -59 -60 -59 -60 -156 155 c-139 138 -160 155 -190 155 -30
0 -50 -16 -177 -142 -78 -78 -144 -140 -147 -137 -4 5 -436 1165 -444 1192 -4
17 -1 16 49 -2 30 -11 297 -111 594 -221z"
                                                        />
                                                    </g>
                                                </svg>
                                                {priceText} &nbsp;
                                            </span>
                                            <span
                                                style={{
                                                    color: colors?.primaryTextColor,
                                                }}
                                            >
                                                {currencySymbol} {price}
                                            </span>
                                        </>
                                    )}
                                </div>
                            ) : (
                                <span
                                    className="ab-our-price"
                                    style={{ color: colors?.primaryTextColor }}
                                >
                                    {priceText}
                                </span>
                            )}
                        </button>
                    </form>
                </div>
            )}
        </>
    );
};

MobileWidgetHeaderBtn.propTypes = {
    price: PropTypes.string.isRequired,
    priceText: PropTypes.string,
    currencySymbol: PropTypes.string.isRequired,
    url: PropTypes.string,
    colors: PropTypes.object.isRequired,
    handleClick: PropTypes.func.isRequired,
    disableArrowBtn: PropTypes.bool.isRequired,
    showAlways: PropTypes.bool,
    classes: PropTypes.string,
    styles: PropTypes.object,
};

export default MobileWidgetHeaderBtn;
